import styled from 'styled-components';
import { Button } from '@tvg/fuse-design';

export default styled(Button)`
  width: 100%;
`;
